// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListSettingsManagement-space1-LX3Ay {
	margin-bottom: 6px !important;
}

.ListSettingsManagement-space2-L75cw {
	margin-bottom: 12px !important;
}

.ListSettingsManagement-space3-Mr3Cf {
	margin-bottom: 18px !important;
}

.ListSettingsManagement-space4-fu3r8 {
	margin-bottom: 24px !important;
}

.ListSettingsManagement-space5-T26V7 {
	margin-bottom: 30px !important;
}

.ListSettingsManagement-space6-F9Y1V {
	margin-bottom: 36px !important;
}

.ListSettingsManagement-space7-U2XsY {
	margin-bottom: 42px !important;
}

.ListSettingsManagement-space8-CiYmB {
	margin-bottom: 48px !important;
}

.ListSettingsManagement-spaceTop1-iCif9 {
	margin-top: 6px !important;
}

.ListSettingsManagement-spaceTop2-aDOxp {
	margin-top: 12px !important;
}

.ListSettingsManagement-spaceTop3-waG8p {
	margin-top: 18px !important;
}

.ListSettingsManagement-spaceTop4-uWQtB {
	margin-top: 24px !important;
}

.ListSettingsManagement-spaceTop5-nNDZG {
	margin-top: 30px !important;
}

.ListSettingsManagement-spaceTop6-crXZ7 {
	margin-top: 36px !important;
}

.ListSettingsManagement-spaceTop7-YZt5S {
	margin-top: 42px !important;
}

.ListSettingsManagement-spaceTop8-_dGln {
	margin-top: 48px !important;
}

.ListSettingsManagement-noMargin-sR3kq {
	margin: 0px !important;
}

.ListSettingsManagement-padding1-YmMc_ {
	padding-bottom: 6px !important;
}

.ListSettingsManagement-padding2-TZ2ui {
	padding-bottom: 12px !important;
}

.ListSettingsManagement-padding3-JliKK {
	padding-bottom: 18px !important;
}

.ListSettingsManagement-padding4-lzbqT {
	padding-bottom: 24px !important;
}

.ListSettingsManagement-padding5-JRFSP {
	padding-bottom: 30px !important;
}

.ListSettingsManagement-padding6-EdoyP {
	padding-bottom: 36px !important;
}

.ListSettingsManagement-padding7-RbSuI {
	padding-bottom: 42px !important;
}

.ListSettingsManagement-paddingTop1-wntZk {
	padding-top: 6px !important;
}

.ListSettingsManagement-paddingTop2-Uy9Dh {
	padding-top: 12px !important;
}

.ListSettingsManagement-paddingTop3-CDqWl {
	padding-top: 18px !important;
}

.ListSettingsManagement-paddingTop4-zv9_m {
	padding-top: 24px !important;
}

.ListSettingsManagement-paddingTop5-l_FIN {
	padding-top: 30px !important;
}

.ListSettingsManagement-paddingTop6-N8gD3 {
	padding-top: 36px !important;
}

.ListSettingsManagement-paddingTop7-eiRE2 {
	padding-top: 42px !important;
}

.ListSettingsManagement-noPadding-ZUrb3 {
	padding: 0px !important;
}

.ListSettingsManagement-spaceMarginBottom0-ivxRr {
	margin-bottom: 0;
}

.ListSettingsManagement-textBold-jbXjr {
	font-weight: 500 !important;
}

.ListSettingsManagement-textBolder-W8KbL {
	font-weight: 700 !important;
}

.ListSettingsManagement-textNormal-s8SN1 {
	font-weight: normal !important;
}

/*New Design Text Colors */

.ListSettingsManagement-textDarkBlue-looQi {
	color: rgb(20, 39, 94) !important;
}

.ListSettingsManagement-textLightBlue-cquKK {
	color: rgb(57, 87, 106) !important;
}

.ListSettingsManagement-textLightSandleGreen-kA8AT {
	color: rgb(76, 86, 41) !important;
}

.ListSettingsManagement-textLightBrown-W4VBe {
	color: rgb(115, 79, 33) !important;
}

.ListSettingsManagement-textMediumMaroon-vaTRe {
	color: rgb(87, 37, 51) !important;
}

.ListSettingsManagement-textBrown-wxce2 {
	color: rgb(160, 47, 24) !important;
}

.ListSettingsManagement-textMaroon-idFqv {
	color: rgb(155, 49, 67) !important;
}

.ListSettingsManagement-textDarkBrown-pXEjC {
	color: rgb(83, 18, 16) !important;
}

.ListSettingsManagement-textMediumBrown-R12vU {
	color: rgb(142, 28, 10) !important;
}

.ListSettingsManagement-textSkyBlue-ZnJOq {
	color: rgb(37, 117, 141) !important;
}

.ListSettingsManagement-textGray-pfBqn {
	color: rgb(77, 65, 51) !important;
}

.ListSettingsManagement-errorMessage-meGWD {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.ListSettingsManagement-userText-DTBbv {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.ListSettingsManagement-panelHeader-Lj3gQ {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.ListSettingsManagement-exportSection-rAAXM {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.ListSettingsManagement-exportSectionGridSub-NrqYH {
	grid-template-columns: 50% 49% !important;
}

.ListSettingsManagement-exportText-lQeLI {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.ListSettingsManagement-exportLinkImg-UUnys {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.ListSettingsManagement-exportImg-JoAel {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ListSettingsManagement-linkBtn-tgopN {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.ListSettingsManagement-table-LbpBq {
	display: table;
}

.ListSettingsManagement-tableRow-R6YZ_ {
	display: table-row;
}

.ListSettingsManagement-tableCell-F9rNf {
	display: table-cell;
	float: none;
}

.ListSettingsManagement-formGroup-Md9VK {
	margin-bottom: 6px;
}

.ListSettingsManagement-marginTop0-ma0A2 {
	margin-top: 0;
}

.ListSettingsManagement-marginBottom20-np75u {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.ListSettingsManagement-bannerImageBg-CVXe2 {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.ListSettingsManagement-bannerDelete-etj7o {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.ListSettingsManagement-exportLink-XaeaD {
	padding-top: 10px;
	padding-right: 10px;
}

.ListSettingsManagement-seachContent-Zw00k {
	padding-left: 0px;
	margin-bottom: 5px;
}

.ListSettingsManagement-marginBottom9-Lz8hW {
	margin-bottom: 9px;
}

.ListSettingsManagement-spaceTop52-rPMEK {
	margin-top: 52px;
}

.ListSettingsManagement-profileViewInner-ds9z7 {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.ListSettingsManagement-profileViewMain-TJP8o {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.ListSettingsManagement-profileViewlabel-OK5dv {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.ListSettingsManagement-profileViewMainContent-y10jo {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.ListSettingsManagement-reviewsFormStar-XcUVp {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.ListSettingsManagement-reviewsFormStar-XcUVp svg {
	cursor: pointer;
}

.ListSettingsManagement-addLanguageText-qpDcv {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.ListSettingsManagement-exportSection-rAAXM {
		grid-template-columns: 100%;
	}

	.ListSettingsManagement-spaceTop52-rPMEK {
		margin-top: 18px;
	}

	.ListSettingsManagement-exportText-lQeLI {
		float: none;
		margin-top: 12px;
	}

	.ListSettingsManagement-exportSectionGridSub-NrqYH {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.ListSettingsManagement-profileViewlabel-OK5dv {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ListSettingsManagement-profileViewMainContent-y10jo {
		width: 100%;
		text-align: center;
	}

	.ListSettingsManagement-panelHeader-Lj3gQ {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.ListSettingsManagement-gap-a8gWX {
    gap: 10px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.ListSettingsManagement-importMakeGap-HQQRv {
    gap: 20px;
}

.ListSettingsManagement-tooltipIconGap-NNMma {
    gap: 6px;
}

.ListSettingsManagement-tooltipIcon-nnAMN {
	position: relative;
}

.ListSettingsManagement-toolTipText-f4zRo {
    display: none;
    position: absolute;
	top: 30px;
	right: auto;
	left: auto;
	display: none;
	background: var(--common-background-color);
	min-width: 200px;
	text-align: center;
	padding: 10px;
	border-radius: 6px;
	color: var(--white-text);
    z-index: 6;
    -webkit-transition: width 2s;
    transition: width 2s;
}

.ListSettingsManagement-tooltipIcon-nnAMN:hover .ListSettingsManagement-toolTipText-f4zRo {
	display: block;
}

@media screen and (max-width: 767px) {
    .ListSettingsManagement-exportSmapleSheetMobileView-U807P  {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
    }

    .ListSettingsManagement-importMakeGap-HQQRv {
        gap: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/ListSettingsManagement/ListSettingsManagement.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACtN3E;IACI,SAAS;IACT,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,QAAQ;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;CACrB,SAAS;CACT,WAAW;CACX,UAAU;CACV,aAAa;CACb,0CAA0C;CAC1C,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;CACb,kBAAkB;CAClB,wBAAwB;IACrB,UAAU;IACV,4BAAoB;IAApB,oBAAoB;AACxB;;AAEA;CACC,cAAc;AACf;;AAEA;IACI;QACI,4BAAsB;QAAtB,6BAAsB;YAAtB,0BAAsB;gBAAtB,sBAAsB;QACtB,wBAAuB;YAAvB,qBAAuB;gBAAvB,uBAAuB;IAC3B;;IAEA;QACI,SAAS;IACb;AACJ","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../admin-common.css';\n\n.gap {\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.importMakeGap {\n    gap: 20px;\n}\n\n.tooltipIconGap {\n    gap: 6px;\n}\n\n.tooltipIcon {\n\tposition: relative;\n}\n\n.toolTipText {\n    display: none;\n    position: absolute;\n\ttop: 30px;\n\tright: auto;\n\tleft: auto;\n\tdisplay: none;\n\tbackground: var(--common-background-color);\n\tmin-width: 200px;\n\ttext-align: center;\n\tpadding: 10px;\n\tborder-radius: 6px;\n\tcolor: var(--white-text);\n    z-index: 6;\n    transition: width 2s;\n}\n\n.tooltipIcon:hover .toolTipText {\n\tdisplay: block;\n}\n\n@media screen and (max-width: 767px) {\n    .exportSmapleSheetMobileView  {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .importMakeGap {\n        gap: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `ListSettingsManagement-space1-LX3Ay`,
	"space2": `ListSettingsManagement-space2-L75cw`,
	"space3": `ListSettingsManagement-space3-Mr3Cf`,
	"space4": `ListSettingsManagement-space4-fu3r8`,
	"space5": `ListSettingsManagement-space5-T26V7`,
	"space6": `ListSettingsManagement-space6-F9Y1V`,
	"space7": `ListSettingsManagement-space7-U2XsY`,
	"space8": `ListSettingsManagement-space8-CiYmB`,
	"spaceTop1": `ListSettingsManagement-spaceTop1-iCif9`,
	"spaceTop2": `ListSettingsManagement-spaceTop2-aDOxp`,
	"spaceTop3": `ListSettingsManagement-spaceTop3-waG8p`,
	"spaceTop4": `ListSettingsManagement-spaceTop4-uWQtB`,
	"spaceTop5": `ListSettingsManagement-spaceTop5-nNDZG`,
	"spaceTop6": `ListSettingsManagement-spaceTop6-crXZ7`,
	"spaceTop7": `ListSettingsManagement-spaceTop7-YZt5S`,
	"spaceTop8": `ListSettingsManagement-spaceTop8-_dGln`,
	"noMargin": `ListSettingsManagement-noMargin-sR3kq`,
	"padding1": `ListSettingsManagement-padding1-YmMc_`,
	"padding2": `ListSettingsManagement-padding2-TZ2ui`,
	"padding3": `ListSettingsManagement-padding3-JliKK`,
	"padding4": `ListSettingsManagement-padding4-lzbqT`,
	"padding5": `ListSettingsManagement-padding5-JRFSP`,
	"padding6": `ListSettingsManagement-padding6-EdoyP`,
	"padding7": `ListSettingsManagement-padding7-RbSuI`,
	"paddingTop1": `ListSettingsManagement-paddingTop1-wntZk`,
	"paddingTop2": `ListSettingsManagement-paddingTop2-Uy9Dh`,
	"paddingTop3": `ListSettingsManagement-paddingTop3-CDqWl`,
	"paddingTop4": `ListSettingsManagement-paddingTop4-zv9_m`,
	"paddingTop5": `ListSettingsManagement-paddingTop5-l_FIN`,
	"paddingTop6": `ListSettingsManagement-paddingTop6-N8gD3`,
	"paddingTop7": `ListSettingsManagement-paddingTop7-eiRE2`,
	"noPadding": `ListSettingsManagement-noPadding-ZUrb3`,
	"spaceMarginBottom0": `ListSettingsManagement-spaceMarginBottom0-ivxRr`,
	"textBold": `ListSettingsManagement-textBold-jbXjr`,
	"textBolder": `ListSettingsManagement-textBolder-W8KbL`,
	"textNormal": `ListSettingsManagement-textNormal-s8SN1`,
	"textDarkBlue": `ListSettingsManagement-textDarkBlue-looQi`,
	"textLightBlue": `ListSettingsManagement-textLightBlue-cquKK`,
	"textLightSandleGreen": `ListSettingsManagement-textLightSandleGreen-kA8AT`,
	"textLightBrown": `ListSettingsManagement-textLightBrown-W4VBe`,
	"textMediumMaroon": `ListSettingsManagement-textMediumMaroon-vaTRe`,
	"textBrown": `ListSettingsManagement-textBrown-wxce2`,
	"textMaroon": `ListSettingsManagement-textMaroon-idFqv`,
	"textDarkBrown": `ListSettingsManagement-textDarkBrown-pXEjC`,
	"textMediumBrown": `ListSettingsManagement-textMediumBrown-R12vU`,
	"textSkyBlue": `ListSettingsManagement-textSkyBlue-ZnJOq`,
	"textGray": `ListSettingsManagement-textGray-pfBqn`,
	"errorMessage": `ListSettingsManagement-errorMessage-meGWD`,
	"userText": `ListSettingsManagement-userText-DTBbv`,
	"panelHeader": `ListSettingsManagement-panelHeader-Lj3gQ`,
	"exportSection": `ListSettingsManagement-exportSection-rAAXM`,
	"exportSectionGridSub": `ListSettingsManagement-exportSectionGridSub-NrqYH`,
	"exportText": `ListSettingsManagement-exportText-lQeLI`,
	"exportLinkImg": `ListSettingsManagement-exportLinkImg-UUnys`,
	"exportImg": `ListSettingsManagement-exportImg-JoAel`,
	"linkBtn": `ListSettingsManagement-linkBtn-tgopN`,
	"table": `ListSettingsManagement-table-LbpBq`,
	"tableRow": `ListSettingsManagement-tableRow-R6YZ_`,
	"tableCell": `ListSettingsManagement-tableCell-F9rNf`,
	"formGroup": `ListSettingsManagement-formGroup-Md9VK`,
	"marginTop0": `ListSettingsManagement-marginTop0-ma0A2`,
	"marginBottom20": `ListSettingsManagement-marginBottom20-np75u`,
	"bannerImageBg": `ListSettingsManagement-bannerImageBg-CVXe2`,
	"bannerDelete": `ListSettingsManagement-bannerDelete-etj7o`,
	"exportLink": `ListSettingsManagement-exportLink-XaeaD`,
	"seachContent": `ListSettingsManagement-seachContent-Zw00k`,
	"marginBottom9": `ListSettingsManagement-marginBottom9-Lz8hW`,
	"spaceTop52": `ListSettingsManagement-spaceTop52-rPMEK`,
	"profileViewInner": `ListSettingsManagement-profileViewInner-ds9z7`,
	"profileViewMain": `ListSettingsManagement-profileViewMain-TJP8o`,
	"profileViewlabel": `ListSettingsManagement-profileViewlabel-OK5dv`,
	"profileViewMainContent": `ListSettingsManagement-profileViewMainContent-y10jo`,
	"reviewsFormStar": `ListSettingsManagement-reviewsFormStar-XcUVp`,
	"addLanguageText": `ListSettingsManagement-addLanguageText-qpDcv`,
	"gap": `ListSettingsManagement-gap-a8gWX`,
	"importMakeGap": `ListSettingsManagement-importMakeGap-HQQRv`,
	"tooltipIconGap": `ListSettingsManagement-tooltipIconGap-NNMma`,
	"tooltipIcon": `ListSettingsManagement-tooltipIcon-nnAMN`,
	"toolTipText": `ListSettingsManagement-toolTipText-f4zRo`,
	"exportSmapleSheetMobileView": `ListSettingsManagement-exportSmapleSheetMobileView-U807P`
};
module.exports = ___CSS_LOADER_EXPORT___;
